import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalRecords,
  onPageChange,
}) => {
  const handleFirstPage = () => onPageChange(1);
  const handlePrevPage = () => onPageChange(Math.max(currentPage - 1, 1));
  const handleNextPage = () => onPageChange(Math.min(currentPage + 1, totalPages));
  const handleLastPage = () => onPageChange(totalPages);

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div>
        <span>Total de registros: {totalRecords}</span>
      </div>
      {totalPages > 1 && (
        <nav>
          <ul className="pagination pagination-sm ">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="btn btn-primary me-2 btn-sm" onClick={handleFirstPage} disabled={currentPage === 1}> <i className="bi bi-chevron-double-left"></i> Primeira</button>
            </li>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="btn btn-primary me-2 btn-sm" onClick={handlePrevPage} disabled={currentPage === 1}> <i className="bi bi-chevron-left"></i> Anterior</button>
            </li>
            <li className="page-item me-2" aria-current="page">
              <span className="page-link">
                Página {currentPage} de {totalPages}
              </span>
            </li>
            <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
              <button className="btn btn-primary me-2 btn-sm" onClick={handleNextPage} disabled={currentPage === totalPages || totalPages === 0}>Próxima <i className="bi bi-chevron-right"></i></button>
            </li>
            <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
              <button className="btn btn-primary me-2 btn-sm" onClick={handleLastPage} disabled={currentPage === totalPages || totalPages === 0}>Última <i className="bi bi-chevron-double-right"></i></button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Pagination;